var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vip_home_div"},[_c('Vip')],1)}
var staticRenderFns = []

export { render, staticRenderFns }